import { Fragment, useCallback, useEffect, useState } from "react";
import { ModalLabels } from "../../assets/labels/labels";
import appConfig from "../../core/appConfig";
import { Company } from "../../core/models/company.model";
import { IconSquareChecked, IconSquareUnchecked } from "../../assets/svgs-index";
import LinkButton from "../buttons/LinkButton/LinkButton";
import ModalIAgree from "./ModalIAgree";
import { AuthenticationService } from "../../core/services/authentication.service";

interface ModalRegisterContentProps {
  company: Company | undefined
}

const ModalLoggedInContent = (props: ModalRegisterContentProps) => {
  const { company } = props;
  const [iAgree, setIAgree] = useState<boolean>(false);
  const [modalIAgreeConfirmText, setModalIAgreeConfirmText] = useState<string>("");
  const [modalIAgreeShowClose, setModalIAgreeShowClose] = useState<boolean>(false);
  const [modalIAgreeIsOpen, setModalIAgreeIsOpen] = useState<boolean>(false);
  const [replaceCompanyName, setReplaceCompanyName] = useState<string>("");
  const [replaceVat, setReplaceVat] = useState<string>("");
  const [replaceClient, setReplaceClient] = useState<string>("");
  const [replaceItem, setReplaceItem] = useState<string>("");
  const [replaceWork, setReplaceWork] = useState<string>("");
  const [replaceCompanies] = useState<string>("");
  const [companyTerms, setCompanyTerms] = useState<string>("");

  const setCompanyIAgreeData = useCallback((domain) => {
    if (!domain) return;
    AuthenticationService.serviceGetCompanyIAgreeData(domain).then((res) => {
      if (res) {
        if (res.client && res.client.length > 0) {
          const clientString = res.client.join(', ');
          setReplaceClient(clientString);
        }
        if (res.item && res.item.length > 0) {
          let itemString = res.item.join(', ');
          if (res.client) itemString = ', ' + itemString;
          setReplaceItem(itemString);
        }
        if (res.work && res.work.length > 0) {
          let workString = res.work.join(', ');
          if (res.item || res.client) workString = ', ' + workString;
          setReplaceWork(workString);
        }
        if (res.vat) {
          setReplaceVat(res.vat);
        }
        if (res.name) {
          setReplaceCompanyName(res.name);
        }
        if (res.terms) {
          setCompanyTerms(res.terms);
        }
      }
    }).catch((error: Error) => {
      console.error("Error fetching company data: ", error.message);
    });
  }, [setReplaceClient, setReplaceItem, setReplaceWork, setReplaceVat, setReplaceCompanyName]);

  useEffect(() => {
    const domain = company?.domain?.replace('.qa', '');
    if (domain) setCompanyIAgreeData(domain);
  }, [company, setCompanyIAgreeData]);

  // Function to handle checkbox change
  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIAgree(event.target.checked);
  };

  const iAgreeModal = (shouldRunFunctionOnClose: boolean = false, showClose: boolean = false) => {
    setModalIAgreeConfirmText("Continuar");
    setModalIAgreeShowClose(showClose);
    setModalIAgreeIsOpen(true);
  }

  const closeIAgreeModal = () => {
    setModalIAgreeIsOpen(false);
    setModalIAgreeConfirmText("");
    setModalIAgreeShowClose(true);
  };

  const renderIAgree = () => {
    return (
      <>
        <div className="input-label mt-4 i-agree-container justify-content-center" style={{ display: 'flex', alignItems: 'center', paddingLeft: '4px', height: 'auto', whiteSpace: 'nowrap' }}>
          <label htmlFor="agreeCheckbox" className="i-agree-label" style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
            <input
              type="checkbox"
              checked={iAgree}
              onChange={handleCheckboxChange}
              id="agreeCheckbox"
              className="agree-checkbox"
              style={{ cursor: 'pointer', transform: 'scale(1.3)', display: iAgree ? 'none' : 'inline-block' }}  // Hide the default checkbox
            />
            <span
              className="custom-checkbox"
              style={{
                width: '20px',
                height: '20px',
                display: iAgree ? 'inline-block' : 'none',
                backgroundImage: iAgree ? `url(${IconSquareChecked})` : `url(${IconSquareUnchecked})`,
                backgroundSize: 'cover',
                marginRight: '0px',
                marginLeft: '-6px',
                cursor: 'pointer',
              }}
            />
            <span style={{ paddingRight: '0px', paddingLeft: '8px', cursor: 'pointer', fontSize: '15px' }}>Li e concordo </span>
            <span style={{ paddingRight: '4px', paddingLeft: '3px', cursor: 'pointer' }}> com a</span>
          </label>
          <div className="i-agree-link" style={{ flexShrink: 0 }}>
            <LinkButton
              onClick={() => iAgreeModal(false, true)}
              styleClass="link-container"
              textClass="small light"
              valueText={companyTerms? "Política de Privacidade e Condições Gerais" : "Política de Privacidade"}
            />
          </div>
        </div>
      </>
    );
  };


  const renderModalIAgree = (handler: any) => {
    if (!modalIAgreeIsOpen) {
      return <Fragment />;
    }
    return (
      <ModalIAgree
        modalIsOpen={modalIAgreeIsOpen}
        confirmText={modalIAgreeConfirmText}
        onClose={() => closeIAgreeModal()}
        onConfirm={handler || closeIAgreeModal}
        showClose={modalIAgreeShowClose}
        replaceCompanyName={replaceCompanyName}
        replaceVat={replaceVat}
        replaceClient={replaceClient}
        replaceItem={replaceItem}
        replaceWork={replaceWork}
        replaceCompanies={replaceCompanies}
        companyTerms={companyTerms}
      />
    );
  };

  const handleGotoClient = () => {
    const url = new URL(`https://${company?.domain}.${appConfig.DOMAIN}/client/services`);
    url.searchParams.append('iagree', iAgree.toString());
    window.open(url.href, '_self');
  }
  return (
    <>
      <div className="modal-register-section w-100 d-flex justify-content-center flex-column">
        <div className="modal-register-title container">
          <h2 className="text-center">{ModalLabels.modalRegisterTitle(company?.name)}</h2>
        </div>
        {renderIAgree()}
        <div className="cta-buttons-container mt-5 d-flex flex-column justify-content-center align-items-center">
          <button
            className={`cta-button-primary w-100 ${!iAgree ? 'disabled' : ''}`}
            onClick={handleGotoClient}
            disabled={!iAgree} // Disable the button when iAgree is false
          >
            Entrar!
          </button>
        </div>
      </div>
      {renderModalIAgree(null)}
    </>
  );
}

export default ModalLoggedInContent;